import {NgModule} from "@angular/core";
import {SharedModule} from "../../../shared.module";
import {ProductBuyBoxComponent} from "./product-buy-box.component";
import {ProductSelectionModule} from "../../product-selection/product-selection.module";

@NgModule({
    imports: [SharedModule, ProductSelectionModule],
    declarations: [ProductBuyBoxComponent],
    exports: [ProductBuyBoxComponent]
})
export class ProductBuyBoxModule { }
